'use client'

import { createContext, useEffect, JSX } from 'react'

import { useTokenPrices } from '~/hooks/useTokenPrices'

const SplitsContext = createContext(undefined)

export function SplitsProvider({
  children,
}: {
  children: JSX.Element
}): JSX.Element {
  const { resolvePricingCalls } = useTokenPrices()

  useEffect(() => {
    resolvePricingCalls()
  }, [resolvePricingCalls])

  return <SplitsContext value={undefined}>{children}</SplitsContext>
}
